import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../Components/Login";
import MyProfile from "../Components/MyProfile";
import DeptMyProfile from "../Components/DeptMyProfile";
import CitizenDashboard from "../Components/CitizenDashboard";
import SideBar from "../Components/SideBar";
import UpdateCitizenProfile from "../Components/UpdateCitizenProfile";
import UpdatePassword from "../Components/UpdatePassword";
import { useSelector } from "react-redux";
import CitizenSchemeDetails from "../Components/CitizenSchemeDetails";
import WaterBill from "../Components/DomainPages/WaterBill";
import DeptDashboard from "../Components/DepartmentComponent/DeptDashboard";
import AddAdmin from "../Components/DepartmentComponent/AddAdmin";
import Aawaas from "../Components/DomainPages/Aawas";
import CitizensCentric from "../Components/DomainPages/CitizensCentric";
import Bhoomi from "../Components/DomainPages/Bhoomi";
import Idli from "../Components/DomainPages/Idli";
import Opd from "../Components/DomainPages/Opd";
import OnlineBookingCommunity from "../Components/DomainPages/OnlineBookingCommunity";
import OnlineMeasurementEMB from "../Components/DomainPages/OnlineMeasurementEMB";
import SwitchUser from "../Components/DepartmentComponent/SwitchUser";
import DeptUserDashboard from "../Components/DepartmentComponent/DeptUserDashboard";
import UserManagement from "../Components/DepartmentComponent/UserManagement";
import AdminSchemeDetails from "../Components/DepartmentComponent/AdminSchemeDetails";
import SelectCitizenUser from "../Components/SelectCitizenUser";
import MyProfileRegister from "../Components/MyProfileRegister";
import ExpressionWillingness from "../Components/DomainPages/ExpressionWillingness";
import FAQs from "../Components/FAQs";

const Routing = () => {
  const isLogin = useSelector((state) => state.auth);
  // console.log(isLogin);
  const userType = localStorage.getItem("userType");

  return (
    <>
      {/* {isLogin.signIn === true ? (
        <SideBar>
          <Routes>
           
            <Route path="/deptmyprofile" element={<DeptMyProfile />} />
            <Route path="/citizendashboard" element={<CitizenDashboard />} />
            <Route path="/Updatecitizenprofile" element={<UpdateCitizenProfile/>}/>
            <Route path="/updatepassword" element={<UpdatePassword/>}/>
            <Route path="/citizenSchemeDetails" element={<CitizenSchemeDetails/>}/>
            <Route path="/WB" element={<WaterBill/>}/>
          </Routes>
        </SideBar>
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/deptmyprofile" element={<DeptMyProfile />} />
          
          
        </Routes>
      )} */}

      {isLogin.signIn === true && userType === "0" ? (
        //for citizen
        <SideBar>
          <Routes>
            <Route path="/deptmyprofilr" element={<DeptMyProfile />} />
            <Route path="/citizendashboard" element={<CitizenDashboard />} />
            <Route
              path="/Updatecitizenprofile"
              element={<UpdateCitizenProfile />}
            />
            <Route path="/updatepassword" element={<UpdatePassword />} />
            <Route
              path="/citizenSchemeDetails"
              element={<CitizenSchemeDetails />}
            />
            <Route path="/WB" element={<WaterBill />} />
            <Route path="/AA" element={<Aawaas />} />
            <Route path="/CS" element={<CitizensCentric />} />
            <Route path="/BH" element={<Bhoomi/>}/>
            <Route path="/ID" element={<Idli/>}/>
            <Route path="/OP" element={<Opd/>}/>
            <Route path="/BO" element={<OnlineBookingCommunity/>}/>
            <Route path="/MS" element={<OnlineMeasurementEMB/>}/>
            <Route path="/EW" element={<ExpressionWillingness/>}/>


          </Routes>
        </SideBar>
      ) : isLogin.signIn === true && userType === "1" ? (
        // for admin user
        <SideBar>
          <Routes>
            <Route path="/deptDashboard" element={<DeptDashboard />} />
            <Route path="/deptmyprofile" element={<DeptMyProfile />} />
            <Route path="/addAdmin" element={<AddAdmin />} />
            <Route path="/userManagement" element={<UserManagement/>}/>
            <Route path="/adminSchemeDetails" element={<AdminSchemeDetails/>}/>

          
            {/* <Route path="/switchuser" element={<SwitchUser/>}/> */}
          </Routes>
        </SideBar>
      ) : isLogin.signIn === true && userType === "2" ? (
        // for dept user
        <SideBar>
          <Routes>
            <Route path="/deptUserDashboard" element={<DeptUserDashboard />} />
           
          </Routes>
        </SideBar>
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/selectcitizenuser" element={<SelectCitizenUser/>}/>
          <Route path="/myProfileRegister" element={<MyProfileRegister/>}/>
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/deptmyprofilr" element={<DeptMyProfile />} />
          <Route path="/switchuser" element={<SwitchUser/>}/>
          <Route path="FAQs" element={<FAQs/>}/>
        </Routes>
      )}

     
    </>
  );
};

export default Routing;
